import Input from './input';
import TextArea from './textarea';
import './styles/index.scss';
const ExpandedInput = Input;
ExpandedInput.TextArea = TextArea;
export { TextArea };
export default ExpandedInput;
